import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMailQuestion } from "@tabler/icons-react";
import { SolicitudesRuteoInfoDef } from "./SolicitudesRuteoInfoDef";

export const SolicitudesRuteoIcon = IconMailQuestion;
export const SolicitudesRuteoHelpText = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

export class SolicitudesRuteoInfo extends Entity<SolicitudesRuteoInfoDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new SolicitudesRuteoInfoDef(), parentKeys);
        this.Form = import('./SolicitudesRuteoInfoForm').then((module) => module.SolicitudesRuteoInfoForm);
        this.Title = "Solicitudes de Ruteo";
        this.HelpText = SolicitudesRuteoHelpText;
        this.Icon = SolicitudesRuteoIcon;
    }
}